import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { PlayerHistoryEditPayload } from '@modules/players/submodules/PlayerProfile/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  EDIT_PLAYER_HISTORY_MUTATION_KEY,
  EDIT_PLAYER_HISTORY_QUERY_URL,
  PLAYER_PROFILE_PERMISSIONS,
  PLAYER_TRACKING_HISTORY_QUERY_KEY,
} from '@modules/players/submodules/PlayerProfile/constants';
import { useToastStore } from '@modules/toast/store';

export default function useTrackingHistoryEditMutation(): IContextMutationResult<void, Error, PlayerHistoryEditPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, PlayerHistoryEditPayload>({
    mutationKey: [EDIT_PLAYER_HISTORY_MUTATION_KEY],
    mutationFn: ({
      data,
      playerId,
      historyId,
      merchant,
    }) => fetchPut<void>(
      EDIT_PLAYER_HISTORY_QUERY_URL,
      { ...data },
      {
        permission: PLAYER_PROFILE_PERMISSIONS.PLAYERS_TRACKING,
        urlParams: {
          playerId,
          historyId,
        },
        queryParams: {
          merchant,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYER_TRACKING_HISTORY_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
